export default import.meta.ROLLUP_FILE_URL_7haGRlwED4JkyOuHIL$T3w;